// Faixa no alto do BALCÃO quando não há caixa aberto (30/09/2026). Só avisa:
// a venda continua. As telas descem `TELA_COM_AVISO` para a faixa caber.
import { AlertTriangle } from "lucide-react";

export const TELA_COM_AVISO = "absolute inset-x-0 bottom-0 top-10 z-10";

export default function AvisoCaixaFechado() {
  return (
    <div role="status" data-e2e="aviso-caixa-fechado"
      className="absolute top-0 inset-x-0 h-10 z-20 bg-red-600 text-white text-sm font-bold flex items-center justify-center gap-2 px-4">
      <AlertTriangle className="w-4 h-4 shrink-0" />
      <span className="truncate">Caixa fechado — as vendas não entram no caixa. Abra o caixa em Financeiro → Caixa</span>
    </div>
  );
}
